'use client'

import { useEffect } from 'react'
import { useForm } from 'react-hook-form'

import { useExperiment } from 'rvbr-www/red-testing'

import { useProposalContext } from '@/context/ProposalContext'

import { useAnalytics } from '@/hooks/useAnalytics'
import { triggerTracrTrack } from '@/hooks/useTracking'

export const usePaywall = () => {
  const {
    control,
    watch,
    formState: { isValid }
  } = useForm({
    mode: 'onChange'
  })

  const { activateExperiment } = useExperiment('paywall')
  const { setIsPaywallOpen } = useProposalContext()
  const { getFBData, getGAData } = useAnalytics()

  useEffect(() => {
    activateExperiment()
  }, [])

  const onCloseModal = () => setIsPaywallOpen(false)

  const onClickWhatsapp = async () => {
    triggerTracrTrack('softlead', { cnpj: watch('cnpj') })

    const conversionPayload = {
      facebookContext: getFBData(),
      googleContext: await getGAData(),
      conversionContext: { eventName: 'LeadStart' }
    }

    triggerTracrTrack('conversion', conversionPayload)
  }

  return {
    control,
    isValid,
    onClickWhatsapp,
    onCloseModal
  }
}
